export const HEADER_NAV_ACTION = 'Header Navigation Clicks'
export const HERO_ACTION = 'Hero Section Clicks'
export const SPLASH_PAGE_ACTION = 'Splash Page Clicks'
export const LINKS = 'Links'
export const CLICKS = 'Clicks'
